export default __webpack_public_path__ + "images/351517764e54e5677b68046496c5a1c1-festivals_desktop.webp";